// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.externo-header {
  min-height: 60px;
  padding: 8px 24px;
  margin-top: var(--dev-banner-height, 0px);
}

.login-brand {
  max-height: 44px;
  margin: 0;
  padding: 0;
  object-fit: contain;
}

.card {
  margin-top: 60px;
  border-radius: 8px !important;
}

.card-body {
  padding: 16px !important;
}

.user-menu-wrapper {
  position: relative;
}

.user-menu-trigger {
  background: transparent;
  border: none;
  color: var(--app-white);
  font-weight: var(--app-font-weight-semibold);
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  padding: 4px 8px;
}

.user-menu-dropdown {
  position: absolute;
  right: 0;
  top: calc(100% + 4px);
  background: var(--app-white);
  border-radius: 8px;
  box-shadow: 0 4px 16px var(--app-ink-alpha-150);
  min-width: 240px;
  padding: 12px;
  z-index: 20;
  text-align: left;
}

.user-menu-item {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  background: transparent;
  border: none;
  padding: 8px 4px;
  text-align: left;
  cursor: pointer;
  color: var(--app-legacy-shortcut-text);
}

.user-menu-item:hover {
  background: var(--app-legacy-canvas);
  border-radius: 4px;
}
`, "",{"version":3,"sources":["webpack://./src/app/main/externo/externo.component.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,uBAAuB;EACvB,4CAA4C;EAC5C,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,qBAAqB;EACrB,4BAA4B;EAC5B,kBAAkB;EAClB,+CAA+C;EAC/C,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB","sourcesContent":[".externo-header {\n  min-height: 60px;\n  padding: 8px 24px;\n  margin-top: var(--dev-banner-height, 0px);\n}\n\n.login-brand {\n  max-height: 44px;\n  margin: 0;\n  padding: 0;\n  object-fit: contain;\n}\n\n.card {\n  margin-top: 60px;\n  border-radius: 8px !important;\n}\n\n.card-body {\n  padding: 16px !important;\n}\n\n.user-menu-wrapper {\n  position: relative;\n}\n\n.user-menu-trigger {\n  background: transparent;\n  border: none;\n  color: var(--app-white);\n  font-weight: var(--app-font-weight-semibold);\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  cursor: pointer;\n  padding: 4px 8px;\n}\n\n.user-menu-dropdown {\n  position: absolute;\n  right: 0;\n  top: calc(100% + 4px);\n  background: var(--app-white);\n  border-radius: 8px;\n  box-shadow: 0 4px 16px var(--app-ink-alpha-150);\n  min-width: 240px;\n  padding: 12px;\n  z-index: 20;\n  text-align: left;\n}\n\n.user-menu-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n  background: transparent;\n  border: none;\n  padding: 8px 4px;\n  text-align: left;\n  cursor: pointer;\n  color: var(--app-legacy-shortcut-text);\n}\n\n.user-menu-item:hover {\n  background: var(--app-legacy-canvas);\n  border-radius: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
